

import React, { memo } from 'react';
import cx from 'classnames';
import DataTableHeader from './header/DataTableHeader';
import DataTableBody from './body/DataTableBody';
import '../styles/_data-table-grid.scss';



const DataTableGrid = () =>
<table className={cx('data-table-grid')}>
    <DataTableHeader />

    <DataTableBody />
  </table>;


export default memo(DataTableGrid);